import { render } from "./partnership-opt-ins-input.vue?vue&type=template&id=c9aa0656&scoped=true"
import script from "./partnership-opt-ins-input.vue?vue&type=script&lang=js"
export * from "./partnership-opt-ins-input.vue?vue&type=script&lang=js"

import "./partnership-opt-ins-input.vue?vue&type=style&index=0&id=c9aa0656&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9aa0656"]])

export default __exports__